import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { onRouteChange, type RouteState } from "../router.js";
import "./app-header.js";
import "./app-footer.js";
import "../pages/directory-page.js";
import "../pages/image-detail.js";
import "../pages/vulnerabilities-page.js";

@customElement("app-shell")
export class AppShell extends LitElement {
  @state() private _route: RouteState = { page: "directory", params: {} };

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    onRouteChange((state) => {
      this._route = state;
    });
  }

  private _renderPage() {
    switch (this._route.page) {
      case "directory":
        return html`<directory-page></directory-page>`;
      case "vulnerabilities":
        return html`<vulnerabilities-page></vulnerabilities-page>`;
      case "detail":
        return html`<image-detail .imageName=${this._route.params.name ?? ""}></image-detail>`;
      default:
        return html`
          <div class="text-center py-16">
            <h2 class="text-white text-xl font-bold mb-2">Page Not Found</h2>
            <p class="text-gray-500 text-base">The page you're looking for doesn't exist.</p>
          </div>
        `;
    }
  }

  render() {
    return html`
      <div class="min-h-screen flex flex-col">
        <app-header></app-header>
        <main class="flex-1 max-w-7xl mx-auto w-full px-4 py-6">${this._renderPage()}</main>
        <app-footer></app-footer>
      </div>
    `;
  }
}
